/* "Search a different VIN" and "Browse all models" in the My trailer drawer,
   for the case where the Find your part modal is not already open.

   WHAT WAS WRONG. fx-launch-b.js binds both buttons, but the whole handler is
   inside `if (document.body.classList.contains('vin-modal-open'))`. That is
   true when the drawer was opened from inside the modal, and false when it was
   opened from the My trailer chip in the header, which is the ordinary way to
   reach it. So from the header the buttons did nothing except let the drawer
   close underneath them: no modal, no search, no feedback.

   WHY A SECOND FILE RATHER THAN A FIX IN fx-launch-b.js. That asset is a built
   bundle and the copy in the theme is minified; editing it by hand would mean
   editing minified code and losing it on the next build. This file loads after
   it and handles only the case the original declines to.

   HOW IT OPENS. The <vin-search-modal> element exposes openVinIntent(), which
   opens the modal already on the VIN tab with the field focused, and
   setSearchMode(), which switches tabs. Both were confirmed against the live
   element rather than assumed. If the extension ever renames them this file
   stops acting and the drawer merely closes, which is exactly today's
   behaviour, so a rename degrades rather than breaks.

   CAPTURE, AND ONLY WHEN THE MODAL IS SHUT. fx-launch-b.js also listens in the
   capture phase and calls stopPropagation when the modal is open. Ours checks
   the same flag the opposite way round, so exactly one of the two ever acts on
   a given click. */
(function () {
  'use strict';

  function modalOpen() {
    return document.body.classList.contains('vin-modal-open');
  }

  function closeDrawer() {
    var drawer = document.querySelector('.fx-rc');
    if (drawer) drawer.classList.remove('is-open');
    document.documentElement.classList.remove('fx-recall-lock');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.fx-rc__btn, .fx-rc__lnk');
    if (!btn) return;

    /* fx-launch-b.js owns this click when the modal is already up. */
    if (modalOpen()) return;

    var host = document.querySelector('vin-search-modal');
    if (!host || typeof host.openVinIntent !== 'function') return;

    e.preventDefault();
    e.stopPropagation();
    closeDrawer();

    var wantsModels = btn.classList.contains('fx-rc__lnk');
    host.openVinIntent();

    /* Browse all models wants the identify tab, but the modal has to exist
       before a tab can be chosen, so the mode is set on the next frame rather
       than in the same call. */
    if (wantsModels && typeof host.setSearchMode === 'function') {
      window.setTimeout(function () {
        try { host.setSearchMode('identify'); } catch (err) { /* tab gone */ }
      }, 60);
    }
  }, true);
})();
